function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
export default {
  props: {
    name: {
      type: String
    },
    field: {
      type: String,
      required: true
    },
    type: {
      type: String
    },
    value: {
      type: String,
      default: null
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    operator: {
      type: String,
      default: 'eq'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dependencies: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    requireParents: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.$store.commit('filters/addFilter', {
      id: this.id,
      field: this.field,
      dependencies: this.dependencies,
      operator: this.operator,
      default: this.value,
      disabled: this.disabled
    });
  },
  computed: {
    id: function id() {
      return this.name || this.field;
    },
    isDisabled: {
      get: function get() {
        // Enable/disable logic is in the filter instead of the store since is component-specific:
        // an extension of this component may have different conditions to be shown as disabled.
        return this.$store.getters['filters/isDisabled'](this.id) || this.requireParents && this.$store.getters['filters/parentsEmpty'](this.id);
      },
      set: function set(disabled) {
        this.$store.commit('filters/setDisabled', {
          id: this.id,
          disabled: disabled
        });
      }
    },
    selected: {
      get: function get() {
        return this.$store.getters['filters/selectedValue'](this.id);
      },
      set: function set(v) {
        this.$store.commit('filters/setFilter', _defineProperty({}, this.id, v));
      }
    },
    label: function label() {
      return this.$t("filters.".concat(this.id, ".label"));
    }
  },
  watch: {
    // Enable/disable conditions are project specific and sometimes dynamic,
    // so we have to watch prop changes and update store in order to maintain consistency.
    disabled: {
      immediate: true,
      handler: function handler(value) {
        this.isDisabled = value;
      }
    }
  }
};